import { useBetbook } from "~/store/betbook";

const useFilterStorage = (sportId?: string | string[]) => {
	const store = useBetbook();
	const loaded = ref(false);
	const route = useRoute();
	const key = `${sportId}-filter`;

	watch(
		() => store.filters,
		() => {
			if (loaded.value) {
				try {
					const toSave = { ...store.filters };
					// @ts-ignore
					if (toSave.markets) delete toSave.markets;
					sessionStorage.setItem(key, JSON.stringify(toSave));
				} catch (e) {}
			}
		},
		{ deep: true }
	);

	onBeforeMount(() => {
		if (sportId) {
			try {
				// Reset Filters
				store.resetFilters();
				// Load persisted filters
				const persistedFilter = sessionStorage.getItem(key);
				if (persistedFilter) {
					const filter = JSON.parse(persistedFilter);
					store.filters = { ...store.filters, ...filter };
				}
				// Load query param filters
				const { selectedLeagues, sortOrder, fromStartEpoch, toStartEpoch, minimumOdds, maximumOdds } = route.query;

				if (selectedLeagues) {
					const formatted = (selectedLeagues as string).split(",").map((x) => {
						const split = x.split("_");
						return { regionId: split[0], leagueId: split[1] };
					});
					store.filters.regionAndLeagueIds = formatted;
				}
				if (sortOrder) {
					store.filters.sortOrder = sortOrder as "League";
				}
				if (fromStartEpoch) {
					store.filters.fromStartEpoch = Number(fromStartEpoch);
				}
				if (toStartEpoch) {
					store.filters.toStartEpoch = Number(toStartEpoch);
				}
				if (minimumOdds || maximumOdds) {
					store.filters.odds = {
						minimum: Number(minimumOdds) || 0,
						maximum: Number(maximumOdds) || 0,
					};
				}
				//
				loaded.value = true;
			} catch (e) {}
		}
	});

	onBeforeUnmount(() => {
		loaded.value = false;
	});
};

export default useFilterStorage;
